module.exports = __webpack_public_path__ + "static/media/thomas.04d9fb4f.png";